<button
  [ngClass]="[
    'button',
    'button-' + color,
    'button-' + size,
    'button-width-' + width,
    icon ? 'width-icon-button' : '',
    (!label || label.trim() === '') && icon ? 'icon-only' : '',
    state ? state : '',
    loading ? 'loading' : '',
    selected ? 'selected' : ''
  ]"
  [style.width]="width === 'fixed' ? fixedWidth : null"
  [disabled]="disabled || loading"
  type="button"
>
  <ng-container *ngIf="!loading">
    <mat-icon
      *ngIf="icon && !dsIcon"
      [ngClass]="iconColor"
      class="material-symbols-outlined icon"
      [class.icon-end]="iconPosition === 'end'"
      >{{ icon }}</mat-icon
    >
    <mat-icon
      *ngIf="dsIcon"
      [ngClass]="iconColor"
      class="svg-icon d-flex"
      [svgIcon]="dsIcon"
      [class.icon-end]="iconPosition === 'end'"
    ></mat-icon>
    <span class="label">{{ label }}</span>
  </ng-container>
  <mat-spinner *ngIf="loading" class="spinner" [diameter]="size === 'sm' ? 16 : size === 'md' ? 20 : 24"></mat-spinner>
  <span *ngIf="loading" class="label">{{ loadingText }}</span>
</button>
